import { HttpTokens, GetLegalLor, LorHistoryQuery } from '@/src/types';
import { paramsQueryString } from '@/src/utils';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description get legal LOR (Letter Of Representation) detail by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const LegalLorDetailGet = (
  /** create can also refer to update for draft */
  prefix: string = 'legal/lor',
  id: string,
  query: LorHistoryQuery,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetLegalLor> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  const queryUri = paramsQueryString(`${prefix}/${id}`, query);

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetLegalLor>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetLegalLor>;
};
